Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instgrmClassNames = exports.handleInstagrmLoad = void 0;

var _utils = require("../../utils");

var isInstgrmScriptAdded = false;
var instgrmClassNames = [".instagram-media", ".instagram-media-rendered"].join(",");
exports.instgrmClassNames = instgrmClassNames;
var instgrmEmbedUrl = "https://www.instagram.com/embed.js";

var instgrmProcess = function instgrmProcess() {
  if (typeof window.instgrm !== "undefined" && window.instgrm.Embeds && typeof window.instgrm.Embeds.process === "function") {
    window.instgrm.Embeds.process();
  }
};

var handleInstagrmLoad = function handleInstagrmLoad() {
  if (document.querySelector(instgrmClassNames) !== null) {
    if (!isInstgrmScriptAdded) {
      (0, _utils.createScriptTag)(instgrmEmbedUrl, null);
      isInstgrmScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }

  instgrmProcess();
  return {
    status: 'instgrmProcess'
  };
};

exports.handleInstagrmLoad = handleInstagrmLoad;